import type { ProjectListResponsePageAllOfThreeContentItem } from './projectListResponsePageAllOfThreeContentItem';

export type ProjectListResponsePageAllOfThree = {
  /** 프로젝트 목록 */
  content?: ProjectListResponsePageAllOfThreeContentItem[];
};
